import {createSelector} from 'reselect';

export const getMaterialityByIdSlice = (state) => state.materiality.byId;
export const getAllMateriality = createSelector([getMaterialityByIdSlice], (materialityById) => {
	return Object.values(materialityById ?? {});
});
export const getCurrentMateriality = createSelector([getMaterialityByIdSlice], (materialityById) => {
	return Object.values(materialityById)?.find((materiality) => materiality.isCurrent && !materiality.isPriorYear);
});

// All current (non-prior-year) materiality records. With FilterMaterialityCategory = 4
// the store holds both the Scope & Strategy (auditPhaseID 1) and Conclusion (auditPhaseID 3)
// rows, so the observer emits an update per record by id instead of picking an arbitrary one.
export const getCurrentMaterialityRecords = createSelector([getMaterialityByIdSlice], (materialityById) =>
	Object.values(materialityById ?? {}).filter((materiality) => materiality.isCurrent && !materiality.isPriorYear)
);

export const getPriorYearMateriality = createSelector([getMaterialityByIdSlice], (materialityById) => {
	return Object.values(materialityById)?.find((materiality) => materiality.isCurrent && materiality.isPriorYear);
});

// For Print
export const getMaterialityForPrint = (state) => state.formPrintData?.materiality;

export const getCurrentMaterialityforPrint = createSelector([getMaterialityForPrint], (materiality) => {
	return Object.values(materiality)?.find((materiality) => materiality.isCurrent && !materiality.isPriorYear);
});

export const getPriorYearMaterialityForPrint = createSelector([getMaterialityForPrint], (materiality) => {
	return Object.values(materiality)?.find((materiality) => materiality.isCurrent && materiality.isPriorYear);
});
